module.exports = __webpack_public_path__ + "img/Scottish_Borders.031c4a7f.png";